<template>
  <header class="mb-8 flex justify-center">
    <router-link to="/" class="relative flex items-center justify-center w-24 h-24">
      <svg class="absolute w-full h-full text-brand-blue opacity-50 group-hover:opacity-75 transition-opacity" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle class="logo-ring" cx="50" cy="50" r="45" stroke="currentColor" stroke-width="4" fill="none" />
      </svg>
      <img class="relative h-25 w-auto" src="@/assets/logo.png" alt="Castive Logo">
    </router-link>
  </header>
</template>

<script>
export default {
  name: 'MainHeader',
}
</script>

<style scoped>
.logo-ring {
  stroke-dasharray: 283;
  stroke-dashoffset: 283;
  transform-origin: center;
  /* --- START: ANIMATION DISABLED --- */
  /* The animation is now commented out and will not run. */
  /* animation: draw-and-spin 20s linear infinite; */
  /* --- END: ANIMATION DISABLED --- */
}

@keyframes draw-and-spin {
  0% { stroke-dashoffset: 283; transform: rotate(-90deg); }
  25% { stroke-dashoffset: 0; transform: rotate(270deg); }
  50% { stroke-dashoffset: -283; transform: rotate(630deg); }
  50.01% { stroke-dashoffset: 283; transform: rotate(630deg); }
  100% { stroke-dashoffset: 283; transform: rotate(990deg); }
}

svg {
  filter: drop-shadow(0 0 4px theme('colors.brand.blue'));
}
</style>